(() => {
  const popup = document.querySelector('[data-blu-popup]');

  if (!popup) return;
  if (!popup.querySelector('.blu-popup__dialog')) return;

  const storageKey = popup.dataset.storageKey || 'blu-popup-dismissed';
  const delay = Number(popup.dataset.delay || 900);
  const showOnce = popup.dataset.showOnce === 'true';
  const closeButtons = popup.querySelectorAll('[data-blu-popup-close]');
  const choiceButtons = popup.querySelectorAll('[data-blu-popup-choice]');
  const selectedInput = popup.querySelector('[data-blu-popup-selected]');

  const openPopup = () => {
    if (showOnce && window.localStorage.getItem(storageKey)) return;
    popup.classList.add('is-visible');
    document.documentElement.classList.add('overflow-hidden');
  };

  const closePopup = () => {
    popup.classList.remove('is-visible');
    popup.classList.remove('has-email-step');
    document.documentElement.classList.remove('overflow-hidden');

    if (showOnce) {
      window.localStorage.setItem(storageKey, 'true');
    }
  };

  window.setTimeout(openPopup, delay);

  closeButtons.forEach((button) => button.addEventListener('click', closePopup));

  choiceButtons.forEach((button) => {
    button.addEventListener('click', () => {
      if (selectedInput) selectedInput.value = button.dataset.bluPopupChoice;
      popup.classList.add('has-email-step');
    });
  });

  popup.addEventListener('click', (event) => {
    if (event.target === popup) closePopup();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && popup.classList.contains('is-visible')) closePopup();
  });
})();
